import React, {FunctionComponent} from 'react'

const NoteOptions: FunctionComponent = () => (
  <div className="note-options---panel">
    <div className="note-options--text">
      <p>
        This cell type displays the cell's note contents
        <br />
        Use the <strong>Add a Note</strong> panel to customize
      </p>
    </div>
  </div>
)

export default NoteOptions
